import { createReducer } from 'redux-act';
import actions from '../actions/emailTemplateActions';
import { PAUSE } from 'redux-persist';

const initialState = {

  addEmailTypePending: false,
  addEmailTypeRes: null,
  addEmailTypeError: null,

  getEmailTypePending: false,
  getEmailTypeRes: null,
  getEmailTypeError: null,

  addEmailTemplatePending: false,
  addEmailTemplateRes: null,
  addEmailTemplateError: null,

  getEmailTemplatePending: false,
  getEmailTemplateRes: null,
  getEmailTemplateError: null,

  updateEmailTemplatePending: false,
  updateEmailTemplateRes: null,
  updateEmailTemplateError: null,

  deleteEmailTemplatePending: false,
  deleteEmailTemplateRes: null,
  deleteEmailTemplateError: null,

  removeImagePending: false,
  removeImageRes: null,
  removeImageError: null,

  addActionTemplatePending: false,
  addActionTemplateRes: null,
  addActionTemplateError: null,

  getActionTemplatePending: false,
  getActionTemplateRes: null,
  getActionTemplateError: null,

  UpdataActionTemplatePending: false,
  UpdataActionTemplateRes: null,
  UpdataActionTemplateError: null,

  DeleteActionTemplatePending: false,
  DeleteActionTemplateRes: null,
  DeleteActionTemplateError: null,

  GetActionTypeTemplatePending: false,
  GetActionTypeTemplateRes: null,
  GetActionTypeTemplateError: null,

};
/* Add Email Type Reducers */
const handleAddEmailTypeRequest = state => {
  return {
    ...state,
    ...{
      addEmailTypePending: true,
      addEmailTypeRes: null,
      addEmailTypeError: null,
    },
  };
};
const handleAddEmailTypetSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addEmailTypePending: false,
      addEmailTypeRes: payload,
      addEmailTypeError: null,
    },
  };
};
const handleAddEmailTypeError = (state, payload) => ({
  ...state,
  ...{
    addEmailTypePending: false,
    addEmailTypeRes: null,
    addEmailTypeError: payload,
  },
});


/* Get Email Type Reducers */
const handleGetEmailtypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmailTypePending: true,
      getEmailTypeRes: null,
      getEmailTypeError: null,
    },
  };
};
const handleGetEmailtypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmailTypePending: false,
      getEmailTypeRes: payload,
      getEmailTypeError: null,
    },
  };
};
const handleGetEmailtypeError = (state1, payload) => ({
  ...state1,
  ...{
    getEmailTypePending: false,
    getEmailTypeRes: null,
    getEmailTypeError: payload,
  },
});

/* Add Email Template  Reducers */
const handleEmailTemplateRequest = state1 => {
  return {
    ...state1,
    ...{
      addEmailTemplatePending: true,
      addEmailTemplateRes: null,
      addEmailTemplateError: null,
    },
  };
};
const handleEmailTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addEmailTemplatePending: false,
      addEmailTemplateRes: payload,
      addEmailTemplateError: null,
    },
  };
};
const handleEmailTemplateError = (state1, payload) => ({
  ...state1,
  ...{
    addEmailTemplatePending: false,
    addEmailTemplateRes: null,
    addEmailTemplateError: payload,
  },
});

/* Get Email Template */
const handleGetEmailTemplateRequest = state1 => {
  return {
    ...state1,
    ...{
      getEmailTemplatePending: true,
      getEmailTemplateRes: null,
      getEmailTemplateError: null,
    },
  };
};
const handleGetEmailTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getEmailTemplatePending: false,
      getEmailTemplateRes: payload,
      getEmailTemplateError: null,
    },
  };
};
const handleGetEmailTemplateError = (state1, payload) => ({
  ...state1,
  ...{
    getEmailTemplatePending: false,
    getEmailTemplateRes: null,
    getEmailTemplateError: payload,
  },
});

/* Update Email Template  Reducers */
const handleUpdateEmailTemplateRequest = state1 => {
  return {
    ...state1,
    ...{


      updateEmailTemplatePending: true,
      updateEmailTemplateRes: null,
      updateEmailTemplateError: null,
    },
  };
};
const handleUpdateEmailTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{

      updateEmailTemplatePending: false,
      updateEmailTemplateRes: payload,
      updateEmailTemplateError: null,
    },
  };
};
const handleUpdateEmailTemplateError = (state1, payload) => ({
  ...state1,
  ...{

    updateEmailTemplatePending: false,
    updateEmailTemplateRes: null,
    updateEmailTemplateError: payload,
  },
});

/* Delete Email Template  Reducers */
const handleDeleteEmailTemplateRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteEmailTemplatePending: true,
      deleteEmailTemplateRes: null,
      deleteEmailTemplateError: null,
    },
  };
};
const handleDeleteEmailTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteEmailTemplatePending: false,
      deleteEmailTemplateRes: payload,
      deleteEmailTemplateError: null,
    },
  };
};
const handleDeleteEmailTemplateError = (state1, payload) => ({
  ...state1,
  ...{
    deleteEmailTemplatePending: false,
    deleteEmailTemplateRes: null,
    deleteEmailTemplateError: payload,
  },
});
/* Remove Image In Template  Reducers */
const handleRemoveImageRequest = state1 => {
  return {
    ...state1,
    ...{


      removeImagePending: true,
      removeImageRes: null,
      removeImageError: null
    },
  };
};
const handleRemoveImageSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{

      removeImagePending: false,
      removeImageRes: payload,
      removeImageError: null


    },
  };
};
const handleRemoveImageError = (state1, payload) => ({
  ...state1,
  ...{

    removeImagePending: false,
    removeImageRes: null,
    removeImageError: payload
  },
});

/* Add Action Template Reducers */
const handleAddActionTemplateRequest = state1 => {
  return {
    ...state1,
    ...{

      addActionTemplatePending: true,
      addActionTemplateRes: null,
      addActionTemplateError: null
    },
  };
};
const handleAddActionTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{

      addActionTemplatePending: false,
      addActionTemplateRes: payload,
      addActionTemplateError: null
    },
  };
};
const handleAddActionTemplateError = (state1, payload) => ({
  ...state1,
  ...{

    addActionTemplatePending: false,
    addActionTemplateRes: null,
    addActionTemplateError: payload
  },
});

/* Get Action Template  Reducers */
const handleGetActionTemplateRequest = state1 => {
  return {
    ...state1,
    ...{

      getActionTemplatePending: true,
      getActionTemplateRes: null,
      getActionTemplateError: null,
    },
  };
};
const handleGetActionTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{

      getActionTemplatePending: false,
      getActionTemplateRes: payload,
      getActionTemplateError: null,
    },
  };
};
const handleGetActionTemplateError = (state1, payload) => ({
  ...state1,
  ...{

    getActionTemplatePending: false,
    getActionTemplateRes: null,
    getActionTemplateError: payload,
  },
});


/* Update Action Template  Reducers */
const handleUpdateActionTemplateRequest = state1 => {
  return {
    ...state1,
    ...{

      UpdataActionTemplatePending: true,
      UpdataActionTemplateRes: null,
      UpdataActionTemplateError: null,
    },
  };
};
const handleUpdateActionTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{

      UpdataActionTemplatePending: false,
      UpdataActionTemplateRes: payload,
      UpdataActionTemplateError: null,
    },
  };
};
const handleUpdateActionTemplateError = (state1, payload) => ({
  ...state1,
  ...{

    UpdataActionTemplatePending: false,
    UpdataActionTemplateRes: null,
    UpdataActionTemplateError: payload,
  },
});


/* Delete Action Template  Reducers */
const handleDeleteActionTemplateRequest = state1 => {
  return {
    ...state1,
    ...{

      DeleteActionTemplatePending: true,
      DeleteActionTemplateRes: null,
      DeleteActionTemplateError: null,
    },
  };
};
const handlDeleteActionTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{

      DeleteActionTemplatePending: false,
      DeleteActionTemplateRes: payload,
      DeleteActionTemplateError: null,
    },
  };
};
const handleDeleteActionTemplateError = (state1, payload) => ({
  ...state1,
  ...{

    DeleteActionTemplatePending: false,
    DeleteActionTemplateRes: null,
    DeleteActionTemplateError: payload,
  },
});

/* Get Action Type Template */
const handleGetActionTypeTemplateRequest = state1 => {
  return {
    ...state1,
    ...{

      GetActionTypeTemplatePending: true,
      GetActionTypeTemplateRes: null,
      GetActionTypeTemplateError: null,
    },
  };
};
const handlGetActionTypeTemplateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{

      GetActionTypeTemplatePending: false,
      GetActionTypeTemplateRes: payload,
      GetActionTypeTemplateError: null,
    },
  };
};
const handleGetActionTypeTemplateError = (state1, payload) => ({
  ...state1,
  ...{

    GetActionTypeTemplatePending: false,
    GetActionTypeTemplateRes: null,
    GetActionTypeTemplateError: payload,
  },
});

/* Clear Email Template Store */
const clearEmailTemplateStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_EMAILTYPE_STORE':
      return {
        ...state,
        ...{
          addEmailTypePending: false,
          addEmailTypeRes: null,
          addEmailTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_EMAIL_TYPE_STORE':
      return {
        ...state,
        ...{
          getEmailTypePending: false,
          getEmailTypeRes: null,
          getEmailTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_EMAIL_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          addEmailTemplatePending: false,
          addEmailTemplateRes: null,
          addEmailTemplateError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_EMAIL_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          addEmailTemplatePending: false,
          addEmailTemplateRes: null,
          addEmailTemplateError: null,
        },
      };

    case 'HANDLE_CLEAR_DELETE_EMAIL_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          deleteEmailTemplatePending: false,
          deleteEmailTemplateRes: null,
          deleteEmailTemplateError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_ACTION_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          addActionTemplatePending: false,
          addActionTemplateRes: null,
          addActionTemplateError: null
        },
      };
    case 'HANDLE_CLEAR_DELETE_ACTION_TEMPLATE_STORE':
      return {
        ...state,
        ...{
          DeleteActionTemplatePending: false,
          DeleteActionTemplateRes: null,
          DeleteActionTemplateError: null,
        },
      };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.addEmailTypeRequest]: handleAddEmailTypeRequest,
    [actions.addEmailTypeSuccess]: handleAddEmailTypetSuccess,
    [actions.addEmailTypeError]: handleAddEmailTypeError,

    [actions.getEmailTypeRequest]: handleGetEmailtypeRequest,
    [actions.getEmailTypeSuccess]: handleGetEmailtypeSuccess,
    [actions.getEmailTypeError]: handleGetEmailtypeError,

    [actions.addEmailTemplateRequest]: handleEmailTemplateRequest,
    [actions.addEmailTemplateSuccess]: handleEmailTemplateSuccess,
    [actions.addEmailTemplateError]: handleEmailTemplateError,

    [actions.getEmailTemplateRequest]: handleGetEmailTemplateRequest,
    [actions.getEmailTemplateSuccess]: handleGetEmailTemplateSuccess,
    [actions.getEmailTemplateError]: handleGetEmailTemplateError,

    [actions.updateEmailTemplateRequest]: handleUpdateEmailTemplateRequest,
    [actions.updateEmailTemplateSuccess]: handleUpdateEmailTemplateSuccess,
    [actions.updateEmailTemplateError]: handleUpdateEmailTemplateError,

    [actions.deleteEmailTemplateRequest]: handleDeleteEmailTemplateRequest,
    [actions.deleteEmailTemplateSuccess]: handleDeleteEmailTemplateSuccess,
    [actions.deleteEmailTemplateError]: handleDeleteEmailTemplateError,

    [actions.RemoveImageRequest]: handleRemoveImageRequest,
    [actions.RemoveImageSuccess]: handleRemoveImageSuccess,
    [actions.RemoveImageError]: handleRemoveImageError,

    [actions.AddActionTemplateRequest]: handleAddActionTemplateRequest,
    [actions.AddActionTemplateSuccess]: handleAddActionTemplateSuccess,
    [actions.AddActionTemplateError]: handleAddActionTemplateError,

    [actions.getActionTemplateRequest]: handleGetActionTemplateRequest,
    [actions.getActionTemplateSuccess]: handleGetActionTemplateSuccess,
    [actions.getActionTemplateError]: handleGetActionTemplateError,

    [actions.UpdataActionTemplateRequest]: handleUpdateActionTemplateRequest,
    [actions.UpdataActionTemplateSuccess]: handleUpdateActionTemplateSuccess,
    [actions.UpdataActionTemplateError]: handleUpdateActionTemplateError,

    [actions.DeleteActionTemplateRequest]: handleDeleteActionTemplateRequest,
    [actions.DeleteActionTemplateSuccess]: handlDeleteActionTemplateSuccess,
    [actions.DeleteActionTemplateError]: handleDeleteActionTemplateError,

    [actions.GetActionTypeTemplateRequest]: handleGetActionTypeTemplateRequest,
    [actions.GetActionTypeemplateSuccess]: handlGetActionTypeTemplateSuccess,
    [actions.GetActionTypeemplateError]: handleGetActionTypeTemplateError,

    [actions.handleClearEmailTemplateStore]: clearEmailTemplateStore,
  },
  initialState,
);